// extracted by mini-css-extract-plugin
module.exports = {"bg":"bg_bg__C3vhg","center":"bg_center__2-CBw","options_container":"bg_options_container__1HoQO","text_block":"bg_text_block__2cu61","link":"bg_link__1Bvid"};